import { getElement, getElements, getOffsetTop } from '../utils/functional'

export default class IndexFullBlocks {
  constructor (el) {
    this.els = {
      el,
      fullBlocksContainer: getElement('.sec-FullBlocks'),
      fullBlocksItems: getElement('.sec-FullBlocks_Items'),
      fullBlocks: getElements('.sec-FullBlock'),
      body: getElement('.bdy-Body')
    }

    const offsetTop = getOffsetTop(this.els.fullBlocksContainer)
    // const offsetBottom = this.els.fullBlocksContainer.offsetHeight + offsetTop
    const fullBlocksScrollWidth = this.els.fullBlocksItems.scrollWidth
    const fullBlocksOffsetWidth = this.els.fullBlocksItems.offsetWidth
    if (window.innerWidth > 600) {
      window.addEventListener('wheel', evt => {
        // evt.deltaY > 0 - scrolling down
        if (
          evt.deltaY > 0 &&
          window.scrollY >= offsetTop &&
          this.els.fullBlocksItems.scrollLeft + fullBlocksOffsetWidth !==
            fullBlocksScrollWidth
        ) {
          window.scrollTo(0, offsetTop)
          evt.preventDefault()
          this.replaceVerticalScrollByHorizontal(evt)
        } else if (
          // evt.deltaY > 0 - scrolling up
          evt.deltaY < 0 &&
          window.scrollY <= offsetTop &&
          this.els.fullBlocksItems.scrollLeft !== 0
        ) {
          window.scrollTo(0, offsetTop)
          evt.preventDefault()
          this.replaceVerticalScrollByHorizontal(evt)
        }
      })
    }
  }

  replaceVerticalScrollByHorizontal (event) {
    this.els.fullBlocksItems.scroll(
      this.els.fullBlocksItems.scrollLeft + event.deltaY * 0.5,
      window.scrollY
    )
  }
}
